import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpResponseBase, HttpErrorResponse } from '@angular/common/http'
import { catchError } from 'rxjs/operators/catchError';
import { _throw } from 'rxjs/observable/throw';
import { movieVM } from '../../models/movieVM';
import { AppConstants } from '../../constants/siteConstants';


@Injectable()
export class EventsService {
  constructor(private http: HttpClient) { }

  getAll() {
    debugger;
    return this.http.get<any>(`${AppConstants.baseURL}/events`);
    //.toPromise()
    //  .catch(err => this.handleError(err));
  }

  getBySearch(name: string) {
    debugger;
    return this.http.get<any>(`${AppConstants.baseURL}/events/?name=` + name);
    //.toPromise()
    //  .catch(err => this.handleError(err));
  }
  getEvents() {
    return this.http.get<any>(`${AppConstants.baseURL}/events/`);
  }
  getAllEvents() {
    return this.http.get<any>(`${AppConstants.baseURL}/events/getEvents`);
  }

  getById(id: string) {
    return this.http.get(`${AppConstants.baseURL}/events/eventById?eventId=` + id);
  }

  addEvents(eventsModel: any) {
    // return this.http.post(`${AppConstants.baseURL}/movie/save`, movieModel);

    const uploadReq = new HttpRequest('POST', `${AppConstants.baseURL}/events/save`, eventsModel, {
      reportProgress: true,
    });


    return this.http.post(`${AppConstants.baseURL}/events/save`, eventsModel);
  }

  update(user: movieVM) {
    return this.http.put(`${AppConstants.baseURL}/events/` + user, user);
  }

  deleteEvent(id: number) {
    return this.http.delete(`${AppConstants.baseURL}/movie/deleteEvent/` + id);
  }
  deleteMultipleEvents(ids: any) {
    return this.http.post(`${AppConstants.baseURL}/movie/deleteMultipleEvents`, ids);
  }

  private handleError(error: HttpErrorResponse) {
    debugger;
    let errMsg = '';
    // Client Side Error
    if (error.error instanceof ErrorEvent) {
      errMsg = `Error: ${error.error.message}`;
    }
    else {  // Server Side Error
      errMsg = `Error Code: ${error.status},  Message: ${error.message}`;
    }
    // return an observable
    return _throw(errMsg);
  };

}



// WEBPACK FOOTER //
// ./src/app/services/events/events.service.ts